// import { TNextCheckAt } from '../types/feed'

export const initialState = {
  riskId: null as string | null,
  nextCheck: null as string | null,
  programType: null as string | null,
  recordText: '',
  isError: false,
  selectedCheckboxes: {
    diabetes: false,
    obesity: false,
    smoker: false,
  },
}

export type TActionType =
  | { type: 'ADD_RECORD_INPUT_CHANGE'; payload: string }
  | { type: 'ADD_RECORD_CHECKUP_CHANGE'; payload: string }
  | { type: 'ADD_PROGRAM_TYPE_CHANGE'; payload: string }
  | {
      type: 'ADD_SELECTED_CHECKBOXES_CHANGE'
      payload: { diabetes: boolean; obesity: boolean; smoker: boolean }
    }
  | { type: 'ADD_RECORD_RISK_CHANGE'; payload: string }
  | { type: 'ADD_RECORD_SET_ERROR' }
  | { type: 'ADD_RECORD_SUCCESS' }

export const reducer = (state: typeof initialState, action: TActionType): typeof initialState => {
  switch (action.type) {
    case 'ADD_RECORD_INPUT_CHANGE':
      return {
        ...state,
        recordText: action.payload,
      }
    case 'ADD_RECORD_CHECKUP_CHANGE': {
      return {
        ...state,
        nextCheck: action.payload,
      }
    }
    case 'ADD_PROGRAM_TYPE_CHANGE': {
      return {
        ...state,
        programType: action.payload,
      }
    }
    case 'ADD_SELECTED_CHECKBOXES_CHANGE': {
      return {
        ...state,
        selectedCheckboxes: action.payload,
      }
    }
    case 'ADD_RECORD_RISK_CHANGE': {
      return {
        ...state,
        riskId: action.payload,
      }
    }
    case 'ADD_RECORD_SET_ERROR': {
      return {
        ...state,
        isError: true,
      }
    }
    case 'ADD_RECORD_SUCCESS': {
      return {
        ...state,
        riskId: null,
        nextCheck: null,
        programType: null,
        recordText: '',
        isError: false,
        selectedCheckboxes: {
          diabetes: false,
          obesity: false,
          smoker: false,
        },
      }
    }
  }
}
